import { StrictMode, Component } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import './index.css'
import App from './App.jsx'
import CommHubIndicator from './components/CommHubIndicator'
import SubscriptionGate from './components/SubscriptionGate'
import { getAppPricing } from './config/pricing-config'
import { API_BASE_URL } from './config'

const appPricing = getAppPricing('fire-pos');

// Initialize Sentry for crash reporting
if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE || 'production',
    release: import.meta.env.VITE_SENTRY_RELEASE,
    tracesSampleRate: 0.2,
  });
}

class RootErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    console.error('[EmberPOS Root Crash]', error, errorInfo)
    Sentry.captureException(error, { contexts: { react: { componentStack: errorInfo?.componentStack } } })
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#1a1a2e', color: '#fff', fontFamily: 'system-ui', padding: '2rem' }}>
          <div style={{ maxWidth: '500px', textAlign: 'center' }}>
            <h1 style={{ fontSize: '2rem', marginBottom: '1rem', color: '#f87171' }}>EmberPOS Crashed</h1>
            <p style={{ marginBottom: '1.5rem', color: '#9ca3af' }}>The application encountered a critical error. Your order data is safe.</p>
            <button
              onClick={() => window.location.reload()}
              style={{ padding: '0.75rem 2rem', background: '#f97316', color: '#fff', border: 'none', borderRadius: '0.5rem', fontSize: '1rem', fontWeight: 'bold', cursor: 'pointer' }}
            >
              Restart EmberPOS
            </button>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <RootErrorBoundary>
      {/* ticket 4556: was hardcoded to .../auth, the 4-digit-PIN employee
          clock-in router (server/routes/auth.js) — wrong router entirely for
          the SaaS owner account login. tenants.js (register/login/me) is the
          real account router; Apple purchase/restore calls their own fixed
          paths off API_BASE_URL (src/services/appStorePurchase.js), not this
          authUrl. */}
      <SubscriptionGate appId="fire-pos" pricing={appPricing} authUrl={`${API_BASE_URL}/api/tenants`}>
        <App />
        {import.meta.env.DEV && <CommHubIndicator project="fire-pos" />}
      </SubscriptionGate>
    </RootErrorBoundary>
  </StrictMode>,
)
